import type { AnchorHTMLAttributes } from 'react';

import { IconCircle } from 'components/Icon';
import Img from 'components/Img';
import Link from 'components/Link';
import { cn } from 'utils/classNames';

interface Props extends AnchorHTMLAttributes<HTMLAnchorElement> {
	className?: string;
	href: string;
	imgHeight: number;
	imgSrc: string;
	imgWidth: number;
	orientation?: 'landscape' | 'portrait';
	text: string;
}

/** Linked image with arrow icon. */
export default function MicroContentMedia({
	className,
	href,
	imgHeight,
	imgSrc,
	imgWidth,
	orientation = 'landscape',
	text,
	...attrs
}: Props) {
	return (
		<Link
			{...attrs}
			href={href}
			className={cn(
				'group/micro-media inline-block overflow-hidden rounded-xs bg-brand align-top text-md text-inverse hover:bg-brandHover forced-colors:border',
				className,
			)}
		>
			{/* Skip alt text on purpose since the link has a proper text below. */}
			<Img
				src={imgSrc}
				alt=""
				width={imgWidth}
				height={imgHeight}
				className="w-full"
			/>
			<span
				className={cn(
					'flex',
					orientation === 'landscape' &&
						'min-h-16 items-center gap-4 px-4 py-2',
					orientation === 'portrait' && 'flex-col gap-3 p-4',
				)}
			>
				<span className="grow group-hover/micro-media:underline">{text}</span>
				<IconCircle name="arrow-forward" variant="base" />
			</span>
		</Link>
	);
}
MicroContentMedia.displayName = 'MicroContentMedia';
